"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
// import GoogleLogin, { GoogleLoginResponse } from 'react-google-login'
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const components_1 = require("@/components");
const social_signins_1 = __importDefault(require("@/components/social-signins"));
const constants_1 = __importStar(require("@/constants"));
const forms_1 = require("@/forms");
const redux_1 = require("@/redux");
const api_payloads_1 = require("@/redux/api-payloads");
const selectors_1 = __importDefault(require("@/selectors"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const LoginScreen = ({ user }) => {
    if (user) {
        return react_1.default.createElement(react_router_1.Redirect, { to: constants_1.Routes.Subscriptions });
    }
    return (react_1.default.createElement("div", { className: styles_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_scss_1.default.leftContainer },
            react_1.default.createElement("div", { className: styles_scss_1.default.formContainer },
                react_1.default.createElement("h4", { className: styles_scss_1.default.title }, constants_1.default.login.welcome),
                react_1.default.createElement(social_signins_1.default, { buttons: { google: true, apple: true } }),
                react_1.default.createElement("p", { className: styles_scss_1.default.description }, constants_1.default.login.description),
                react_1.default.createElement(forms_1.LoginForm, null),
                react_1.default.createElement("div", { className: styles_scss_1.default.signUpContainer },
                    react_1.default.createElement("div", { className: styles_scss_1.default.textContainer },
                        react_1.default.createElement("p", null, constants_1.default.login.dontHaveAnAccount),
                        react_1.default.createElement(components_1.Link, { to: constants_1.Routes.SignUp, className: styles_scss_1.default.signUpButton },
                            react_1.default.createElement("span", null, constants_1.default.login.signUp)))))),
        react_1.default.createElement("div", { className: styles_scss_1.default.rightContainer },
            react_1.default.createElement("img", { src: constants_1.Images.loginBackground, alt: constants_1.Images.loginBackground }))));
};
const mapStateToProps = (state) => ({
    user: selectors_1.default.user.getUser(state),
});
const mapDispatchToProps = {
    loginWithGoogle: (accessToken) => redux_1.ActionCreators.api.makeRequest.dispatch((0, api_payloads_1.authenticateGooglePayload)(accessToken)),
};
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(LoginScreen);
